// frontend/src/features/categories/EditCategory.js
import { useParams } from 'react-router-dom';
import EditCategoryForm from './EditCategoryForm';
import { useGetAllCategoriesAdminQuery, selectCategoryByIdForAdmin } from './categoriesApiSlice';
import useAuth from '../../hooks/useAuth';
import useTitle from '../../hooks/useTitle';
import { Spinner, Alert, Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const EditCategory = () => {
    useTitle('Nirakar Satguru: Edit Category');

    const { id: categoryId } = useParams();
    const { isManager, isAdmin } = useAuth();

    const { pageNumber = 1, searchQuery = '', isActiveFilter = '' } = useSelector((state) => state.category);
    const queryArgs = { page: pageNumber, search: searchQuery, isActive: isActiveFilter };

    const {
        data: categoriesData,
        isLoading: isCategoriesLoading,
        isError: isCategoriesError,
        error: categoriesError,
        isSuccess: isCategoriesSuccess
    } = useGetAllCategoriesAdminQuery(queryArgs);

    const category = useSelector(state =>
        selectCategoryByIdForAdmin(state, queryArgs, categoryId) // Correct usage with queryArgs
    );

    if (isCategoriesLoading) {
        return <div className="text-center my-5"><Spinner animation="border" role="status" /><p className="mt-2">Loading categories...</p></div>;
    }

    if (isCategoriesError) {
        return <Alert variant="danger" className="text-center my-5">{categoriesError?.data?.message || 'Error loading categories.'}</Alert>;
    }

    if (isCategoriesSuccess && !category) {
        return <p className="errmsg text-center my-5">Category with ID "{categoryId}" not found or not on the current page of results.</p>;
    }

    if (!isManager && !isAdmin) {
        return <Alert variant="danger" className="text-center my-5">You do not have permission to edit categories.</Alert>;
    }

    const content = (
        <Container className="my-4">
            <EditCategoryForm category={category} />
        </Container>
    );

    return content;
};

export default EditCategory;